/* istanbul ignore file */
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { QueryKey } from "../constants";
import { useStanClient } from "../use-stan-client";
import { TasksListResponse, RemediationTaskApprovalStatus } from "stan-client";

export const useApproveTasks = ({
  onSuccess,
  ...options
}: UseMutationOptions<void, Error, string[], unknown> = {}) => {
  const client = useStanClient();

  return useMutation({
    mutationKey: QueryKey.RemediationTasksApprove,
    mutationFn: async (ids: string[]) => {
      await client.approveTasks(ids);
    },
    onSuccess: async (data, ids, result, context) => {
      await Promise.all([
        context.client.cancelQueries({
          queryKey: QueryKey.RemediationTasks,
        }),
        context.client.cancelQueries({
          queryKey: QueryKey.RemediationTasksReject,
        }),
      ]);

      const previousTasks = context.client.getQueryData(
        QueryKey.RemediationTasks
      ) as TasksListResponse;

      const lookup = new Set(ids);

      const withoutCurrent = previousTasks.tasks.filter(
        // TODO: Fix Orval + Pydantic default_factory
        (t) => !lookup.has(t.id!)
      );

      const currents = previousTasks.tasks.filter((t) =>
        // TODO: Fix Orval + Pydantic default_factory
        lookup.has(t.id!)
      );

      const newResult: TasksListResponse = {
        total: previousTasks.total,
        tasks: [
          ...withoutCurrent,
          ...currents.map((t) => ({
            ...t,
            approval_status: RemediationTaskApprovalStatus.Approved,
          })),
        ],
      };

      context.client.setQueryData(QueryKey.RemediationTasks, newResult);

      onSuccess?.(data, ids, result, context);
    },
    ...options,
  });
};
